import MobileNav from './header/mobile-nav';
import Search from './header/search';

window.addEventListener('load', () => {
  document.body.classList.remove('preload');
});

MobileNav();
Search();
